import Vue from 'vue'
import App from './App.vue'
import router from './router'
import qs from 'qs'
import i18n from './lang'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from '@/store'
import {$get,$postJson,$postX,$postFile} from "@/ajax"
import { API_BASE_URL } from '@/config'
import { optimizeImageUrl, IMAGE_WIDTH } from '@/utils/imageUrl'

Vue.prototype.qs = qs
Vue.prototype.apiBaseUrl = API_BASE_URL
Vue.prototype.$imgUrl = optimizeImageUrl
Vue.prototype.$imgWidth = IMAGE_WIDTH
Vue.prototype.$get = $get
Vue.prototype.$postJson = $postJson
Vue.prototype.$postX = $postX
Vue.prototype.$postFile = $postFile
Vue.config.productionTip = false

Vue.use(ElementUI,{
  i18n: (key, value) => i18n.t(key, value)
})

router.afterEach(() => {
  document.documentElement.scrollTop = 0;
})

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
